<template>

    <div class="contentGlobal extra">
      <Navigation> </Navigation>
      <b-button-group class="menuListTop">
        <b-button class="menuTop" style="margin:0px;" @click="viewMode = 'table'" :pressed="viewMode=='table'">
          <icon name="list"></icon>
        </b-button>
        <b-button v-if="!hideSlide" class="menuTop" style="margin:0px;" @click="viewMode = 'slide'" :pressed="viewMode=='slide'">
          <icon name="desktop"></icon>
        </b-button>
    
      </b-button-group>
      <div v-if="viewMode == 'table'" class="listContainer">
        <div class="int pTop">
          <b-col cols="3" class="inputSearch">
                  <b-input-group>
                      <b-form-input v-model="filter" :placeholder="$t('messages.typeToSearch')" />
                      <b-input-group-append>
                      <b-btn :disabled="!filter" @click="filter = ''"> <icon name="times-circle"></icon></b-btn>
                      </b-input-group-append>
                  </b-input-group>
          </b-col>
          <div style="height:400px;">
            <b-row class="pt-4" cols="4">
              <b-table class="poolTable" ref="table" head-variant="light" hover
                :fields="fields"
                :items="pools"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :sort-compare="sortCompare"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="actions" slot-scope="row">
                    <router-link class="btnTable" :to="`/detail/${row.item.id}`"><icon name="eye"></icon> </router-link> 
                    <router-link class="btnTable" :to="`/pool-detail/${row.item.id}`"> <icon name="edit"></icon>  </router-link>
                    <b-btn v-b-modal.unsubscribe @click="selectedPoolId = row.item.id" class="btnTable"><icon name="trash"></icon></b-btn>
                </template>
                <template v-if="row.item.main" slot="main.temperature" slot-scope="row">
                  {{ getTemp(row.item.main) }}
                </template>
                <template slot="id" slot-scope="row">
                  {{ row.item.id }}
                </template>
  
                <template slot="form.name" slot-scope="row">
                  {{ (hasCustomName(row.item.form)) ? hasCustomName(row.item.form) : row.item.form.name }}
                </template>
  
                <template slot="present" slot-scope="row">
                  <span v-bind:class="(row.item.present)?'green':'red'">{{ (row.item.present) ? $t("messages.yes") : $t("messages.no") }}</span>
                </template>
  
                <template v-if="row.item.main" slot="main.localTime" slot-scope="row">
                  {{ $moment.unix(row.item.main.localTime).utc().format("DD-MM-YYYY HH:mm") }}
                </template>
                <template v-if="row.item.filtration" slot="filtration.mode" slot-scope="row">
                  {{ getFiltrationMode(row.item.filtration.mode) }} -
                  <span v-bind:class="(row.item.filtration.status === 1)?'green':'red'">{{ (row.item.filtration.status === 1) ? "ON" : "OFF" }}</span>
                </template>
  
                <template slot="updatedAt" slot-scope="row">
                  {{ row.item.updatedAt | moment("DD-MM-YYYY HH:mm") }}
                </template>
  
                <template v-if="row.item.light" slot="light.mode" slot-scope="row">
                  {{ getLightMode(row.item.light.mode) }} -
                  <span v-bind:class="(row.item.light.status === 1)?'green':'red'">{{ (row.item.light.status === 1) ? "ON" : "OFF" }}</span>
                </template>
  
                <template v-if="row.item.main" slot="main.RSSI" slot-scope="row">
                  <span v-bind:class="( getRSSI(row.item.main.RSSI) )"> {{ row.item.main.RSSI < 0 ? row.item.main.RSSI +' dBm': 'N/A' }} </span>
                </template>
              </b-table>
            </b-row>
            <b-row align-h="center">
              <b-pagination class="pagination" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
            </b-row>
          </div>
        </div>
      </div>
  
      <div class="content inner" v-else-if="viewMode == 'slide'">
        <div class="int" v-if="!hideSlide">
          <b-container fluid>
            <div class="slider w100">
              <b-carousel v-if="pools.length"
                id="carousel1"
                controls
                indicators
                img-width="1024"
                img-height="150"
                :interval="40000000"
                v-model="slide"
              >
                <b-carousel-slide v-for="pool in pools" :key="pool.reference">
                  <pool-global :pool="pool" mode="slide"></pool-global>
                </b-carousel-slide>
              </b-carousel>
            </div>
          </b-container>
        </div>
      </div>
      <div class="content inner double" v-else>
        <div class="int pTop">
          <b-container fluid>
            <div class="slider">
              <b-col cols="12">
                <b-row align-h="center">
                  <div v-for="pool in listPools" :key="pool.reference" class="blockPool">
                    <pool-global :pool="pool"></pool-global>
                  </div>
                </b-row>
                <b-row align-h="center">
                  <b-pagination :total-rows="totalRows"  v-model="currentPage" :per-page="perPage" />
                </b-row>
              </b-col>
              
            </div>
          </b-container>
  
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import PoolGlobal from "./Pool";
  const fb = require('../firebaseConfig.js')
  import Navigation from './Navigation.vue'
  export default {
    name: "Demo",
    components: {
      PoolGlobal,
      Navigation
    },
    data() {
      return {
        main:null,
        msg: "",
        viewMode: "slide",
        hideSlide: false,
        slide: 0,
        sortBy: null,
        sortDesc: false,
        sortDirection: "desc",
        currentPage: 1,
        perPage: 10,
        filter: null,
        totalRows: 0,
        selectedPoolId: null,
        currentPage: 1,
        perPage: 6,
        pools:[],
        fields: [
          // Node ID, Name, Temperature, Filtration, Lighting, Local time, Updated at, Actions
          {key: "id",label: this.$i18n.t("messages.nodeID"),t: "messages.nodeID",sortable: true,shortcode: "pn"},
          {key: "form.name",label: this.$i18n.t("messages.login.name"),t: "messages.login.name",sortable: true},
          {key: "present",label: this.$i18n.t("messages.connected"),t: "messages.connected",},
          {key: "main.temperature",label: this.$i18n.t("messages.temperature"),t: "messages.temperature"},
          {key: "filtration.mode",label: this.$i18n.t("messages.filtration"),t: "messages.filtration"},
          {key: "light.mode",label: this.$i18n.t("messages.lighting"),t: "messages.lighting"},
          {key: "main.localTime",label: this.$i18n.t("messages.localTime"),t: "messages.localTime"},
          {key: "updatedAt",label: this.$i18n.t("messages.updatedAt"),t: "messages.updatedAt"},
          {key: "main.RSSI",label:"Wifi RSSI"},
        ]
      };
    },
    watch: {
      "$i18n.locale": function(oldV, newV) {
        this.resetColumns();
      },
  
    },
    created(){
      this.getPool();
      this.intervalid1 = setInterval(function(){
        var _pool = this.pools[0];
         _pool.main.localTime = Date.now()/1000;
    }.bind(this), 10000);
    },
    computed: {
        listPools() {
            const items = this.pools
        
            // Return just page of items needed
            return items.slice(
            (this.currentPage - 1) * this.perPage,
            this.currentPage * this.perPage
            )
        },
    },
    methods: {
      getPool(){
        fb.poolsDemoCollection.doc('8PUMEXYSUCQZSTLLODDU').onSnapshot(res => {
            if(res.exists){
                let pool = res.data();
                pool.id = res.id;
                pool.isDemo = true;
                pool.main.localTime = Date.now()/1000;
                pool.updatedAt = Date.now();

                this.pools = [];
                this.pools.push(pool)
                // store.commit('getWeather', pool)
            }
        })
      },

      hasCustomName(item){
        if(item.names){
          for (var uid of Object.keys(item.names)) {
            if(this.currentUser.uid == item.names[uid].user){
              return item.names[uid].name
            } 
          }
        }
      },
      getFiltrationMode(val) {
        var _str = "messages."+this.$store.getters.getFiltrationMode(val).toLowerCase();
        return this.$t(_str).toUpperCase();
      },
      getTemp(val) {
        try{
          return (val.hideTemperature==0) ? val.temperature+' Cº' : '--'
        }catch(err){
  
        } 
      },
      resetColumns() {
       if(!this.$refs.table) return 
        this.$refs.table.fields.forEach(column => {
          if (column.t) {
            column.label = this.$i18n.t(column.t);
          }
        });
      },
      getRSSI(val) {
        var _val = Math.abs(val);
        if(_val> 0 && _val<=58){
          return "green"
        }else if(_val >58 && _val < 68){
          return "orange"
        }else if(_val >= 68){
          return "red"
        }else{
          return "grey"
        }
      },
      getLightMode(val) {
        var value = "";
        switch (val) {
          // MAN, AUTO
          case 0:
            value = "MANUAL";
            break;
          case 1:
            value = "AUTO";
            break;
          default:
            value = "MAN";
            break;
        }
        return value;
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      sortCompare(a, b, key) {
        if (key === "main.localTime.seconds") {
          var a = a.main.localTime.seconds;
          var b = b.main.localTime.seconds;
          if (a < b) {
            return 1;
          } else if (a > b) {
            return -1;
          } else if (a == b) {
            return 0;
          }
        } else if (key === "form.reference") {
          if (a.form.reference < b.form.reference) {
            return 1;
          } else if (a.form.reference > b.form.reference) {
            return -1;
          } else if (a.form.reference == b.form.reference) {
            return 0;
          }
        } else if (key === "form.name") {
          if (a.form.name < b.form.name) {
            return 1;
          } else if (a.form.name > b.form.name) {
            return -1;
          } else if (a.form.name == b.form.name) {
            return 0;
          }
        }
      }
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/Demo.vue